import { IntlShape } from 'react-intl';
import * as Yup from 'yup';

export const RLAVRMDialogSchema = ({ formatMessage }: IntlShape) =>
    Yup.object({
        question1: Yup.string()
            .oneOf(['yes', 'no'])
            .required(
                formatMessage({
                    id: 'schema.errors.required_answer',
                    defaultMessage: 'You must answer the question',
                })
            ),
        question2: Yup.string()
            .oneOf(['yes', 'no'])
            .required(
                formatMessage({
                    id: 'schema.errors.required_answer',
                    defaultMessage: 'You must answer the question',
                })
            ),
    });
